/**
 * Carries a renter's typed preferences on proto.
 */
export class ProtoUserSettingsDto {
  id!: number;
  userId!: number;
  languageId?: number | null;
  timezone?: string | null;
}
